export function isUrlValid(url) {
    try {
        const u = new URL(url);
        return (/^(http|https):\/\/([-._~:/?#[\]@!$&'()*+,;=a-zA-Z0-9]|%[0-9a-fA-F]{2})+$/.test(url) &&
            /^([-.a-zA-Z0-9])+$/.test(u.hostname) &&
            /^(?!\/\/).*$/.test(u.pathname));
    }
    catch (_a) {
        return false;
    }
}
//# sourceMappingURL=UrlHelper.js.map